import { createContext, PropsWithChildren, useReducer } from 'react';
import { language } from './common/constants';
import { ActionTypes, BookingStep } from './types/bookingFormTypes';

export interface IBookingContext extends IBookingState {
  setHotel: (hotelId: number) => void;
}

export const BookingContext = createContext<IBookingContext>({} as any);

export interface IBookingState {
  step: BookingStep;
  stepTitle: string;
  hotelId?: number;
}

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export const bookingReducer = (state: IBookingState, action: IAction): IBookingState => {
  switch (action.type) {
    case ActionTypes.SetHotel:
      state = {
        ...state,
        step: BookingStep.ChooseDateTime,
        stepTitle: language.CHOOSE_DATETIME_TITLE,
        hotelId: action.payload?.hotelId,
      };
      break;
    default:
      break;
  }

  return state;
};

const initialState: IBookingState = {
  step: 0,
  stepTitle: language.CHOOSE_LOCATION_TITLE,
};

export const BookingContextProvider = ({ children }: PropsWithChildren<any>) => {
  const [state, dispatch] = useReducer(bookingReducer, initialState);
  const setHotel = (hotelId: number) => {
    dispatch({
      type: ActionTypes.SetHotel,
      payload: {
        hotelId,
      },
    });
  };

  return (
    <BookingContext.Provider
      value={{
        ...state,
        setHotel,
      }}>
      {children}
    </BookingContext.Provider>
  );
};
